<template>
  <ul class="mainNavList">
    <li
      v-for="item in navList"
      :key="item.id"
      @click="mySlideTo(item.id)"
      :class="item.id === nowPage ? 'active' : ''"
    >
      <span :style="{opacity: item.id === nowPage ? 1 : 0}">|</span> {{item.title}}
    </li>
  </ul>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import { navList } from './data'

export default {
  mixins: [swiperMixin],
  data () {
    return {
      navList, // 右侧导航
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './mainTitle.styl'
</style>